import { LINE_BREAK } from './constants';

export const splitTextByLineBreaks = (text: string) => {
  const lineBreaks = getLineBreaks(text);

  const lines: Array<string> = [];
  let currentStart = 0;

  for (const lineEnd of [...lineBreaks, text.length]) {
    const lineText = text.slice(currentStart, lineEnd);

    lines.push(lineText);

    // Skip over line break characters
    if (lineEnd < text.length) {
      if (
        text[lineEnd] === LINE_BREAK.CR &&
        text[lineEnd + 1] === LINE_BREAK.LF
      ) {
        // Windows line break: skip both \r and \n
        currentStart = lineEnd + 2;
      } else {
        // Unix/Mac line break: skip one character
        currentStart = lineEnd + 1;
      }
    }
  }

  return lines;
};

const getLineBreaks = (text: string) => {
  const lineBreaks: Array<number> = [];

  for (let i = 0; i < text.length; i++) {
    // Windows line break: \r\n (treat as one line break)
    if (text[i] === LINE_BREAK.CR && text[i + 1] === LINE_BREAK.LF) {
      // Position of \r (line ends before \r\n)
      lineBreaks.push(i);

      // The for loop will increment i by 1,
      // but windows line break is 2 characters (\r\n)
      // so we need to increment i by 1 to skip both \r and \n
      i++;
    }
    // Unix (\n) or Mac (\r) line break
    else if (text[i] === LINE_BREAK.LF || text[i] === LINE_BREAK.CR) {
      lineBreaks.push(i);
    }
  }
  return lineBreaks;
};
